import React, {
  createContext,
  useContext,
  useEffect,
  useState
} from "react";

import {
  onAuthStateChanged
} from "firebase/auth";

import {
  auth
} from "../firebaseConfig";

// ==========================================
// USER CONTEXT
// ==========================================

const UserContext = createContext(null);

// ==========================================
// USER PROVIDER
// ==========================================

export const UserProvider = ({ children }) => {

  const [user, setUser] = useState(null);

  const [loading, setLoading] = useState(true);

  // ========================================
  // FIREBASE AUTH STATE
  // ========================================

  useEffect(() => {

    const unsubscribe = onAuthStateChanged(
      auth,
      (currentUser) => {

        setUser(currentUser);

        setLoading(false);

      }
    );

    return () => unsubscribe();

  }, []);

  // ========================================
  // CONTEXT VALUE
  // ========================================

  const value = {

    user,

    loading,

    isLoggedIn: !!user

  };

  return (

    <UserContext.Provider value={value}>

      {children}

    </UserContext.Provider>

  );

};

// ==========================================
// USE USER CONTEXT
// ==========================================

export const useUser = () => {

  const context = useContext(UserContext);

  if (!context) {

    throw new Error(
      "useUser must be used inside UserProvider"
    );

  }

  return context;

};

export default UserContext;